"use client";
import React, { useCallback, useEffect, useState } from "react";
import { useAppSelector, useAppDispatch } from "@/lib/hooks";
import { emailSchema } from "@/utils/validation/ContactUsSchema";
import { Form, Formik } from "formik";
import { InputField, Loader } from "@/components/ui";
import {
  emailSubscribe,
  getEmailSubscribeLoading,
} from "@/lib/features/home/homeSlice";
import {Turnstile} from '@/components/ui';
import { showToast } from "@/app/CustomToastProvider";

interface FormValues {
  email: string;
  // turnstile_challenge_token: string;
}
const CallToActions = () => {
  const isLoading = useAppSelector(getEmailSubscribeLoading);
  const dispatch = useAppDispatch();
  const initialValues: FormValues = {
    email: "",
    // turnstile_challenge_token: ""
  };

  const [turnstileToken, setTurnstileToken] = useState<string>('');

  const handleTurnstileVerify = useCallback((token: string) => {
    setTurnstileToken(token);
  },[]);

  const handleTurnstileError = useCallback(() => {
    setTurnstileToken('');
    // showToast('CAPTCHA verification failed. Please try again.', 'danger');
  },[]);

  const handleTurnstileExpire = useCallback(() => {
    setTurnstileToken('');
    // showToast('CAPTCHA expired. Please verify again.', 'danger');
  },[]);

  
  const onSubmit = async (data: FormValues) => {
   /* if (!turnstileToken) {
      showToast('Please complete the CAPTCHA','danger');
      return;
    }
    {...data, turnstile_challenge_token: turnstileToken}
    */
    const response = await dispatch( emailSubscribe({ url: "v1/newsletter-subscribe", payload:  data})).unwrap();
   /* setTurnstileToken('');
    if(typeof window != undefined && window.turnstile ){
      window.turnstile.reset();
    }*/
  };
 /* useEffect(() => {
    if (turnstileToken && window.turnstile) {
      const resetTimeout = setTimeout(() => {
        window.turnstile.reset();
        setTurnstileToken('');
        // showToast('CAPTCHA expired. Please verify again.', 'danger');
      }, 120000); // 2 minutes 120000
  
      return () => clearTimeout(resetTimeout);
    }
  }, [turnstileToken]);*/
  
  return (
    // <section className="layout-pt-md layout-pb-md bg-dark-2" id="journey_section">
      <div className="container bg-dark-2 borderradius-40">
        <div className="row y-gap-50 justify-between items-center">
          <div className="col-auto">
            <div className="row y-gap-20  flex-wrap items-center">
              <div className="col-auto">
                <div className="icon-newsletter text-60 sm:text-40 text-white" />
              </div>
              <div className="col-auto">
                <h4 className="text-26 text-white fw-600">
                  Get fresh travel deals before they disappear
                </h4>
                <div className="text-white">
                  Join the Roave list for app-only offers, price drops, and destination ideas.
                </div>
              </div>
            </div>
          </div>
          {/* End .col */}

          <div className="col-auto">
            <Formik
              enableReinitialize={true}
              initialValues={initialValues}
              validationSchema={emailSchema}
              onSubmit={onSubmit}
            >
              {({ values, errors, touched, setFieldValue }) => (
                <Form>
                  <div className="single-field -w-410 d-flex x-gap-10 y-gap-20">
                    <div>
                      <InputField
                        name="email"
                        placeholder="Enter your email"
                        type="text"
                        parentClassName="borderradius-40"
                        className="bg-white h-60 borderradius-40"
                      />
                  
                   {/* <Turnstile
                      onVerify={handleTurnstileVerify}
                      onError={handleTurnstileError}
                      onExpire={handleTurnstileExpire}
                      siteKey={process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY_NEWSLETTER}
                    /> */}
                    </div>
                    {/* End email input */}

                    <div>
                      <button
                        type="submit"
                        className="button -md h-60 bg-blue-1 text-white"
                      >
                        Send me deals
                        {isLoading && (
                          <Loader show={true}></Loader>
                        )}
                      </button>
                    </div>
                    {/* End subscribe btn */}
                  </div>
                </Form>
              )}
            </Formik>
          </div>
          {/* End .col */}
        </div>
      </div>
    // </section>
  );
};

export default CallToActions;
